module.exports = __webpack_public_path__ + "media/site/images/offers/figure-c1c8f24e6afb62e8d85a7b561981d8d8.svg";